<script>
  import QuestionList from './questions/QuestionList.svelte';
  import CheckIcon from '../icons/CheckIcon.svelte';
  import XMarkIcon from '../icons/XMarkIcon.svelte';
  import DocumentCheck from '../icons/DocumentCheck.svelte';
  import ArrowRight from '../icons/ArrowRight.svelte';
  import Results from './Results.svelte';
  import PieGauge from './PieGauge.svelte';
  let x = -1;
  let questionCount = 12;
  let answers = [];

  function next() {
    x = x + 1;
  }
  function prev() {
    x = x - 1;
  }
  function reset() {
    x = -1;
  }
  function answerNo() {
    answers[x] = false;
    next();
  }
  function answerYes() {
    answers[x] = true;
    next();
  }
</script>

<main>
  {#if x === -1}
    <section class="flex items-center justify-center py-12">
      <button on:click={next} class="flex gap-4 items-center btn-primary">
        <ArrowRight />
        Test starten
      </button>
    </section>
  {:else if x < questionCount}
    <h3 class="flex items-center gap-2">
      <PieGauge progress={x / questionCount} />
      Frage {x + 1} von {questionCount}
    </h3>
    <section>
      <QuestionList currentIndex={x} />
    </section>
    <footer
      class="flex justify-center items-center gap-4 mt-8 flex-wrap flex-col-reverse md:flex-row"
    >
      {#if x > 0}
        <button on:click={prev} class="btn-tertiary md:mr-8 w-full md:w-auto">zurück</button>
      {/if}
      {#if x < questionCount}
        <button on:click={answerNo} class="flex gap-4 items-center btn-primary w-full md:w-auto">
          <XMarkIcon />
          Nein
        </button>
        <button on:click={answerYes} class="flex gap-4 items-center btn-primary w-full md:w-auto">
          <CheckIcon />
          Ja
        </button>
      {/if}
    </footer>
  {:else}
    <Results results={answers} on:restart={reset} />
  {/if}
</main>

<style>
</style>
